import borders from "../base/borders";
import boxShadows from "../base/boxShadows";

const { borderRadius } = borders;
const { xxl } = boxShadows;

export default {
  styleOverrides: {
    root: {
      "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop ": {
        backgroundColor: "rgba(255,255,255,0.1)",
      },
    },
    paper: {
      borderRadius: borderRadius.lg,
      boxShadow: xxl,
    },

    paperFullScreen: {
      borderRadius: 0,
    },
  },
};
